import { Button, ButtonProps, CircularProgress, Collapse } from "@mui/material";
import ButtonDotIcon from "../../features/careers/theme/ButtonDotIcon";

type OutlinedButtonProps = { isLoading?: boolean } & Omit<
  ButtonProps,
  "variant" | "startIcon"
>;
const OutlinedButton: React.FC<OutlinedButtonProps> = ({
  sx,
  isLoading,
  ...props
}) => {
  return (
    <Button
      variant="outlined"
      sx={{
        borderColor: "#E85322",
        backgroundColor: "transparent",
        borderRadius: "56px",
        fontSize: "16px",
        lineHeight: "16px",
        fontWeight: 700,
        height: 65,
        borderWidth: "2px !important",
        ":hover": {
          borderColor: "inherit",
          backgroundColor: "#E8532212",
          borderWidth: "2px",
        },
        "& > span > svg > circle": {
          transition: (theme) => theme.transitions.create("fill"),
          fill: props.disabled ? "rgba(0, 0, 0, 0.26)" : "#E85322",
        },
        ...sx,
      }}
      startIcon={
        isLoading ? (
          <Collapse in={isLoading} orientation="horizontal">
            <CircularProgress
              size={24}
              sx={{ marginRight: 2, marginTop: "2px" }}
            />
          </Collapse>
        ) : (
          <ButtonDotIcon />
        )
      }
      {...props}
    />
  );
};
export default OutlinedButton;
